import { ProjectOption } from 'components';
import styled, { css } from 'styled-components';

export const MyAccountContent = styled.div`
  display: block;
  width: 900px;
  margin: 0 auto;
  max-width: 95%;
  margin-bottom: 3rem;
`;

export const ThumbnailColumn = styled.div`
  width: 90%;
`;

const actionLabelBaseStyles = css`
  font-family: 'Lato', 'helvetica neue', 'helvetica', 'arial', sans-serif;
  text-decoration: underline !important;
  text-transform: uppercase;
  opacity: 1;
  font-size: 11px;
  letter-spacing: 0.15em;
  text-decoration-color: #d2d2d0 !important;
  color: #000;
  transition: color, 0.15s, ease-in;

  &:hover {
    color: #959595;
    cursor: pointer;
  }
`;

export const ActionLabel = styled.label`
  ${actionLabelBaseStyles}

  &:not(:last-child) {
    margin-right: 1rem;
  }
`;

export const StyledProjectOption = styled(ProjectOption)`
  ${actionLabelBaseStyles}
`;

export const HeaderWrapper = styled.div<{ underlined?: boolean }>`
  display: flex;
  align-items: flex-end;
  gap: 3rem;
  height: rem;
  border-bottom: ${({ underlined }) => (underlined ? '1px solid #e9e9e8' : 'none')};
  margin-bottom: ${({ underlined }) => (!underlined ? '0.75rem' : '2rem')};
  padding-bottom: ${({ underlined }) => (underlined ? '1rem' : '0.25rem')};

  > h3 {
    margin: 0;
  }

  > label {
    margin: 0;
    line-height: 1.7rem;
  }

  &:not(:first-child) {
    margin-top: 3rem;
  }

  &:first-child {
    > h3 {
      line-height: 1rem;
    }
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
  }
`;

export const AddressWrapper = styled.div`
  display: inline-block;

  &:not(:last-child) {
    margin-right: 6rem;
  }
`;
